import { render, staticRenderFns } from "./search-bulk-contact-change-entries.vue?vue&type=template&id=b2584456&scoped=true&"
import script from "./search-bulk-contact-change-entries.vue?vue&type=script&lang=js&"
export * from "./search-bulk-contact-change-entries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2584456",
  null
  
)

export default component.exports